import {Route} from "react-router-dom";
import PrivateRoute from "context/PrivateRoute";

import ViewPGA from "./ViewPGA";
import FormBasic from "./FormBasic"
import FormAdvanced from "./FormAdvanced"

const RoutesPGA460 = () => {
    return (
        <>
            <Route path="advanced/pga"
                   element={<PrivateRoute role="superuser"><ViewPGA/></PrivateRoute>}
            />
            <Route path="advanced/pga/basic/:id"
                   element={<PrivateRoute role="superuser"><FormBasic/></PrivateRoute>}
            />
            <Route path="advanced/pga/advanced/:id"
                   element={<PrivateRoute role="superuser"><FormAdvanced/></PrivateRoute>}
            />


        </>
    );
};
export default RoutesPGA460;
